import { Component } from '@angular/core'

@Component({
  selector: 'se-po-ethnicity-select-docs',
  templateUrl: './ethnicity-select-docs.component.html',
  styleUrls: ['./ethnicity-select-docs.component.scss'],
  standalone: false,
})
export class EthnicitySelectDocsComponent {
}
